class BESSAppProjectDetailsProfilerManager extends BESSAppProjectProfilerManager {

    constructor(profiler) {
        super(profiler);
    }

    start() {
        super.start();
        this.siteType = this.getSiteType();
        this.fireEvent(new BESSAppProjectSiteTypeDependencyEvent(this.siteType), false);
    }


    updated() {
        super.updated();
        let siteType = this.getSiteType();
        if(siteType !== this.siteType) {
            this.siteType = siteType;
            this.fireEvent(new BESSAppProjectSiteTypeDependencyEvent(this.siteType, true))
        }
    }

    getSiteType() {
        return this.getProject().valueFor.siteType.value;
    }

    getProject() {
        return this.profiler.data.items[0];
    }
}